import { Component, ElementRef, Input, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { DropdownOperationService } from 'src/app/dropdown-operation.service';
import { ListOperationService } from 'src/app/list-operation.service';
import { FormBuilderUDFService } from 'src/app/services/form-builder-udf-service';
import { Multilingual } from 'src/app/services/multilingual';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { SharedOperationService } from 'src/app/shared-operation.service';
import { FormViewerInterface } from 'src/app/shared/drag-drop-content/interfaces/form-viewer.interface';

@Component({
  selector: 'app-form-viewer',
  templateUrl: './form-viewer.component.html',
  styleUrls: ['./form-viewer.component.scss']
})
export class FormViewerComponent implements OnInit {
  formHtml: SafeHtml;
  private formHtmlLoaded: boolean = false;
  breadcrumList: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  jsonData: any;
  dataObj: any;
  columnDefs: any[] = [];
  rowData: any[] = [];
  frameworkComponents: any;
  idOnEdit: any = '';

  constructor(
    private formService: FormBuilderUDFService,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private renderer: Renderer2,
    private translate: TranslateService,
    private router: Router,
    private usermanagementService: UserManagementService,
    private translater: TranslaterService,
    private toaster: ToastrService,
    private dropdownService: DropdownOperationService,
    private listOperationService : ListOperationService,
    private sharedService : SharedOperationService
  ) {
    this.frameworkComponents = {
      editButtonRenderer: ButtonEditRendererComponent
    };
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
  }
  ngAfterViewInit(): void {

  }

  ngOnInit() {
    this.GetBreadcrumList();
  }

  onGridReady(event: any) {
    console.log('Grid is ready');
  }

  ngAfterViewChecked() {
    if (this.formHtml && !this.formHtmlLoaded) {
      this.addEventListeners();
      this.formHtmlLoaded = true;
    }
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
   
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
        this.getAllForms();
        localStorage.setItem('pageId',this.pageId);// setting pageid and using in sharedservices
        // this.fetchGridData();
      },
      (error:any) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }
  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;

    });
  }

  getAllForms() {
    const key = {
      pageId: this.pageId,
      moduleId: this.moduleId,
    };
    this.formService.getFormByModulePage(key).subscribe((data: any) => {
      this.dataObj = data.Table[0];
      const htmlString = data.Table[0].form_source_code_html;
      this.jsonData = JSON.parse(data.Table[0].form_source_code_json);
      this.formHtml = this.sanitizer.bypassSecurityTrustHtml(htmlString);
      const formViewerData: FormViewerInterface = {
        json_data: this.jsonData,
        html_data: this.formHtml,
        container: this.el,
        renderer: this.renderer,
      };

      this.sharedService.setFormViewerData(formViewerData);
      setTimeout(() => this.sharedService.initializePlugins(), 0);
      //
      setTimeout(() => {
        this.dropdownService.loadAndPopulateComponents(this.jsonData, this.el, this.renderer);
      }, 0);
    }, (error: any) => {
      console.error('Error fetching form HTML:', error);
    });
  }

  addEventListeners() {
    const buttons = this.el.nativeElement.querySelectorAll('button[type="button"]');
    buttons.forEach((button: any) => {
      this.renderer.listen(button, 'click', this.onSubmit.bind(this));
    });
  }

  onSubmit() {
    this.idOnEdit = 0
    this.idOnEdit = localStorage.getItem('rowId');
    const formData = this.sharedService.getFormValues(this.el);
    const gridData = this.listOperationService.getGridData();
    const formDataWithGridData = {
      ...formData,
      gridData: gridData
    };

    const key = {
      id: (!this.idOnEdit || this.idOnEdit === '') ? 0 : this.idOnEdit,
      pageId: this.pageId,
      group : formData?.group?.value,
      plant: formData?.plant?.value,
      formBuilderMainId: this.dataObj?.id,
      formdata: JSON.stringify(formDataWithGridData),
      TransactionType: (!this.idOnEdit || this.idOnEdit === '') ? 1 : 2
    };
    this.formService.saveFormData(key).subscribe(async (response: { Table: { Column1: string | undefined; }[]; }) => {
      this.toaster.success('Success', response.Table[0]?.Column1);
      localStorage.removeItem('rowId');
      this.fetchGridData();
    }, (error: any) => {
      console.error('Error saving form data:', error);
    });
  }

   fetchGridData() {
    for (const component of this.jsonData.added_components) {
      if (component.addedComponents) {
        for (const innerComponents of component.addedComponents) {
          for (const innerComponent of innerComponents) {
           if (innerComponent.elementName === 'list' && innerComponent.element.datasourceUrl) {
              this.listOperationService.createListGrid(innerComponent.element, this.el.nativeElement);
            }
          }
        }
      }
    }
  }

}
